import { useEffect, useState } from "react";
import { Headphones } from "lucide-react";

// Mostra o player apenas se o arquivo de áudio existir em /public/audio.
export default function AudioNote({ src, label, id }) {
  const [ok, setOk] = useState(false);
  useEffect(() => {
    fetch(src, { method: "HEAD" })
      .then((r) => setOk(r.ok && (r.headers.get("content-type") || "").startsWith("audio")))
      .catch(() => setOk(false));
  }, [src]);
  if (!ok) return null;
  return (
    <div className="my-6 rounded-2xl border bg-white/70 p-4" data-testid={`audio-${id}`}>
      <p className="mb-2 flex items-center gap-2 text-sm text-stone-700"><Headphones size={16} /> {label}</p>
      <audio controls preload="metadata" src={src} className="w-full" data-testid={`audio-${id}-player`} />
    </div>
  );
}
